import styled from 'styled-components'

export const CustomerLoginDiv = styled.div`
display:flex;
justify-content:center;
align-items:center;
min-height:100vh;

h3{
        font-style: normal;
        font-weight: bold;
        font-size: 35px;
        line-height: 56px;
    }
p{
    font-size: 18px;
    /* line-height: 22px; */
}

.left-div{
    img{
        width:100px;
    }
    span{
        color: #1E90FF;
    }
   
}
.right-div{
    display:flex;
    flex-direction:column;
  
    form{
        width:75%;
    }
    input{
        :focus{
            box-shadow:none;
        }
        background: rgba(229, 229, 229, 0.4);
        /* height:30px; */
    }
    button{
        width:100%;
        background: #1DCDFE;
        color:#fff;
        :focus{
            box-shadow:none;
    }
    p{
        font-family: Poppins;
        font-style: normal;
        font-weight: 300;
        font-size: 12px;
        line-height: 18px;
    }

    }
} .last-part{
    display:flex;
    width:75%;
    justify-content:space-between;
    padding-top:20px;
    h4{
        font-family: Poppins;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;

        color: #000000;
    }
   span{
    color: #32D272;
    font-weight: bold;
   }
    
}
`